// axios中请求配置有baseURL选项，表示请求URL公共部分。
// `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL
let IBMS_API = "http://144.123.154.238:8021/api/";
// let IBMS_API = "http://192.168.18.56:8001/api/";
export { IBMS_API };
